module.exports = __webpack_public_path__ + "img/112.9e726919.png";